var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.82 12.223c.513.888-.13 2-1.155 2H1.335a1.334 1.334 0 01-1.155-2L6.845.666a1.334 1.334 0 012.31 0l6.665 11.557zM8 9.833a1.278 1.278 0 100 2.556 1.278 1.278 0 000-2.556zm-1.007-.815L6.787 5.24a.333.333 0 01.333-.351h1.76c.192 0 .344.16.333.351l-.206 3.778a.333.333 0 01-.333.315H7.326a.333.333 0 01-.333-.315z",
    fill: "#A81515"
  })));
}
export default SvgWarning;